export default __webpack_public_path__ + "static/white-logo-6e537832c910185d7ddab9ed2592858d.png";